import update from 'immutability-helper';

import { PAGINATION_LIMIT } from '../../../config';

import { DASHBOARD_STATE_QUERY } from '../graphql/DashboardStateQuery.client.gql';

const TYPE_DASHBOARD_STATE = 'DashboardState';

const TYPE_DASHBOARD_STATE_FILTER = 'DashboardFilterInput';

const TYPE_DASHBOARD_STATE_PAGINATION = 'DashboardPaginationInput';

const defaults = {
  dashboardState: {
    filter: {
      __typename: TYPE_DASHBOARD_STATE_FILTER
    },
    orderBy: ['-id'],
    pagination: {
      first: PAGINATION_LIMIT,
      offset: 0,
      __typename: TYPE_DASHBOARD_STATE_PAGINATION
    },
    __typename: TYPE_DASHBOARD_STATE
  }
};

const resolvers = {
  Mutation: {
    updateDashboardFilter: (_, { filter, orderBy, pagination }, { cache }) => {
      const { dashboardState } = cache.readQuery({
        query: DASHBOARD_STATE_QUERY
      });
      const newDashboardState = update(dashboardState, {
        filter: { $merge: filter },
        orderBy: { $set: orderBy },
        pagination: { $merge: pagination }
      });

      cache.writeData({
        data: {
          dashboardState: newDashboardState,
          __type: TYPE_DASHBOARD_STATE
        }
      });

      return null;
    }
  }
};

export default { defaults, resolvers };
